import { createIcon } from "@chakra-ui/react";

const ExitFullScreenIcon = createIcon({
  displayName: "ExitFullScreenIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.75 9.50006V4.00006H14.25V9.50006C14.25 9.63813 14.3619 9.75006 14.5 9.75006H20V11.2501H14.5C13.5335 11.2501 12.75 10.4666 12.75 9.50006Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.25 14.7501L11.25 20.2501H9.75L9.75 14.7501C9.75 14.612 9.63807 14.5001 9.5 14.5001H4L4 13.0001H9.5C10.4665 13.0001 11.25 13.7836 11.25 14.7501Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.46967 19.4697L9.46967 13.4697L10.5303 14.5304L4.53033 20.5304L3.46967 19.4697Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4697 9.46973L19.4697 3.46973L20.5303 4.53039L14.5303 10.5304L13.4697 9.46973Z"
        fill="currentColor"
      />
    </>
  ),
});

export default ExitFullScreenIcon;
